import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined"
import Button from "@mui/material/Button"
import { useState } from "react"

export default function AIGenButton({ campaign, setAIGenerateButtonRef }) {
  return (
    !campaign && (
      <Button
        variant="contained"
        color="primary"
        sx={{ height: "39px" }}
        startIcon={<AutoAwesomeOutlinedIcon />}
        onClick={(e) => setAIGenerateButtonRef(e.currentTarget)}
      >
        AI Gen.
      </Button>
    )
  )
}

export function useAIGenButtonState() {
  const [aiGenerateButtonRef, setAIGenerateButtonRef] = useState(null)
  return {
    aiGenerateButtonRef,
    setAIGenerateButtonRef,
  }
}
